import React, { forwardRef } from 'react';
import { SubSectionContainer } from './sectionStyle';

export const SubSection = forwardRef<HTMLDivElement, { children: React.ReactNode; className?: string }>(({ children, className }, ref) => {
    return (
        <SubSectionContainer ref={ref} className={className}>
            {children}
        </SubSectionContainer>
    );
});
